import { MouseEventHandler } from 'react';
import classNames from 'classnames';
import styles from './BackLink.module.scss';
import { Icon } from 'ui/components';
import IconArrowLeft from 'ui/icons/icon-arrow-back-portal.svg';
import { NextLink } from '../Link/NextLink/NextLink';

export interface BackLinkProps {
	children: React.ReactNode;
	ariaLabel?: string;
	className?: string;
	url?: string;
	locale?: string;
	target?: string;
}

export const BackLink: React.FC<BackLinkProps> = ({ children, ariaLabel, className, url, locale, target }) => {
	return (
		<NextLink href={url} locale={locale} target={target ?? '_self'} aria-label={ariaLabel} className={classNames(styles.BackLink, className)}>
			<Icon className={styles.BackLink_arrow}>
				<IconArrowLeft />
			</Icon>
			{children}
		</NextLink>
	);
};
